import firebase from 'firebase/app';
import { db } from '@/main';

export default {
  namespaced: true,
  state: {
    user: {
      loggedIn: false,
      data: null,
    },
  },
  actions: {
    createUserProfile(context, { uid, userProfile }) {
      return db
        .collection('profiles')
        .doc(uid)
        .set(userProfile);
    },
    getUserProfile({ commit, dispatch }, uid) {
      return db
        .collection('profiles')
        .doc(uid)
        .get()
        .then(snap => {
          const profile = snap.data();
          return profile;
        });
    },
    async fetchUser({ commit, dispatch }, user) {
      if (user) {
        commit('SET_USER', {
          displayName: user.displayName,
          email: user.email,
          uid: user.uid,
          profile: await dispatch('getUserProfile', user.uid),
        });
        commit('SET_LOGGED_IN', true);
      } else {
        commit('SET_USER', null);
        commit('SET_LOGGED_IN', false);
      }
    },
    login(context, { form }) {
      return firebase
        .auth()
        .signInWithEmailAndPassword(form.email, form.password)
        .catch(error => Promise.reject(error.message));
    },
    register(context, { form }) {
      return firebase
        .auth()
        .createUserWithEmailAndPassword(form.email, form.password)
        .then(({ user }) => {
          // ToDo: create profile collection in firestore
          user.updateProfile({
            displayName: form.alias,
          });
          return user;
        })
        .catch(e => {
          const message = e.message;
          return Promise.reject(message);
        });
    },
  },
  mutations: {
    SET_LOGGED_IN(state, value) {
      state.user.loggedIn = value;
    },
    SET_USER(state, data) {
      state.user.data = data;
    },
  },
  computed: {
    rolesInclude(role) {
      return this.state.user.data?.profile ? this.state.user.data.profile.roles.includes(role) : false;
    },
  },
  getters: {
    isAdmin(state) {
      //return this.rolesInclude('admin');
      return state.user.data?.profile ? state.user.data.profile.roles.includes('admin') : false;
    },
    isContributor(state) {
      //return this.rolesInclude('contributor');
      return state.user.data?.profile ? state.user.data.profile.roles.includes('contributor') : false;
    },
    isValidator(state) {
      //return this.rolesInclude('validator');
      return state.user.data?.profile ? state.user.data.profile.roles.includes('validator') : false;
    },
    user(state) {
      return state.user;
    },
    userProfileAlias(state) {
      return state.user.data?.profile?.alias ? state.user.data.profile.alias : '';
    },
  },
};
